import { TableRow } from "@material-ui/core";
import { memo } from "react";
import { useResultadoExercicioService } from "../../contexts/ResultadoExercicioContext";
import AccountTableCell from "./AccountTableCell";
import ConsolidatedReportTableRow from "./ConsolidatedReportTableRow";
import DetailedReportTableRow from "./DetailedReportTableRow";

const RecursiveGroupedTableRow = ({ cell, level }) => {
  const { columns, isConsolidated } = useResultadoExercicioService();

  const children = cell?.children?.map((child, childIndex) => (
    <RecursiveGroupedTableRow cell={child} level={level + 1} key={childIndex} />
  ));

  return (
    <>
      {isConsolidated ? (
        <ConsolidatedReportTableRow
          cell={cell}
          columns={columns}
          level={level}
        />
      ) : (
        <DetailedReportTableRow cell={cell} columns={columns} level={level} />
      )}
      {cell?.accounts?.map((groupedCell, groupIndex) => (
        <TableRow key={`${groupedCell.id}-${groupIndex}`}>
          {columns.map((column) => (
            <AccountTableCell
              key={column.id}
              align={column.align}
              id={column.id}
              paddingLeft={column.id === "categoryDescription" && level * 16}
              data={
                column.format
                  ? column.format(groupedCell[column.id])
                  : groupedCell[column.id]
              }
            />
          ))}
        </TableRow>
      ))}
      {children}
    </>
  );
};

export default memo(RecursiveGroupedTableRow);
